import Hero from "../../components/Hero/Hero";
import GuidelineArticle from "../../components/HomePageComponents/GuidelineArticle/GuidelineArticle";
import News from "../../components/HomePageComponents/News/News";
import Slider from "../../components/HomePageComponents/Slider/Slider";

function HomePage() {
  return (
    <>
      <Hero
        subtitle={
          "This is the Official website of the Environmental Abatement Council of Canada"
        }
      />
      <News />
      <GuidelineArticle />
      <Slider />
    </>
  );
}
export default HomePage;
